module.exports = __webpack_public_path__ + "media/home alone.cb4a435b.mp3";